import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import CriteriaService from "@services/CriteriaService";

export const viewCriteria = createAsyncThunk(
  "criteria/view",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await CriteriaService.viewCriteria({id});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const deleteCriteria = createAsyncThunk(
  "criteria/delete",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await CriteriaService.deleteCriteria({id});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  current: null,
  error: "",
  status: "",
};

const viewCriteriaSlice = createSlice({
  name: "view-criteria",
  initialState,
  reducers: {
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearView() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(viewCriteria.pending, (state) => {
        pendingState(state);
      })
      .addCase(viewCriteria.fulfilled, (state, action) => {
        state.current = action.payload;
        fulfilledState(state);
      })
      .addCase(viewCriteria.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(deleteCriteria.pending, (state) => {
        pendingState(state);
      })
      .addCase(deleteCriteria.fulfilled, (state) => {
        fulfilledState(state);
      })
      .addCase(deleteCriteria.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {clearView, setError, setStatus} = viewCriteriaSlice.actions;

export default viewCriteriaSlice.reducer;
